<template>
  <div class="mb-12">
    <div class="flex items-center flex-wrap p-7  bg-bg rounded border border-border">
      <div class="text-md text-red-dark" v-html="$t('duplicatesWarning', {length: duplicates.length})"></div>
      <BaseButton class="ml-auto"
                  theme="yellow"
                  @click="showDetails = !showDetails">
        <span class="flex items-center">{{ $t('showDuplicates') }}
          <font-awesome-icon class="ml-10"
              :icon="`chevron-${showDetails ? 'up':'down'}`"/></span>
      </BaseButton>
      <DuplicateList class="w-full mt-6" v-if="showDetails"
                     :duplicates="duplicates" @toggle="$emit('toggleExclude',$event)"/>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";
import IconChevron from "@/components/icons/IconChevron";
import DuplicateList
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep2/DuplicateList/DuplicateList";

export default {
  name: "ImportPortfolioDuplicates",
  components: {DuplicateList, IconChevron, AssetIcon, BaseButton},
  data() {
    return {
      showDetails: false,
    }
  },
  props: {
    duplicates: {
      type: Array
    }
  },
  i18n: {
    messages: {
      en: {
        duplicatesWarning: '<span class="font-bold">ATTENTION!</span> The report found {length} of possible duplicates of the operation.',
        showDuplicates: 'Check duplicates'
      },
      ru: {
        duplicatesWarning: '<span class="font-bold">ВНИМАНИЕ!</span> В отчете найдено {length} возможных дублей операции.',
        showDuplicates: 'Проверить дубли'
      }
    }
  }
}
</script>